import { getCurrentInstance } from '@nuxtjs/composition-api'

export function useI18n() {
  const currentInstance = getCurrentInstance()

  if (!currentInstance) {
    throw new Error('useI18n called and got currentInstance of null')
  }

  return {
    $i18n: currentInstance.proxy.$i18n,
    $t: currentInstance.proxy.$t.bind(currentInstance.proxy),
    $te: currentInstance.proxy.$te.bind(currentInstance.proxy),
  }
}
